module.exports = __webpack_public_path__ + "static/img/qudi (1).5895234.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qudi/qudi (1).jpg
// module id = xpCC
// module chunks = 0